import React, { useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { FileUploader } from 'react-drag-drop-files';
import { wsCreate } from 'services/WService';

const fileTypes = ['JPG', 'PNG'];

/**
 * Foto del mueble del catálogo.
 *
 * Ojo con la diferencia: esta es la foto del MODELO de mueble. La del control
 * es la del mueble ya colocado en el cliente, y la de la visita es cómo lo
 * encontró el vendedor. Son tres cosas distintas.
 */
export default function FurniturePhotoModal(props) {
  const { model, setOpen, showNotify, reload } = props;
  const [processing, setProcessing] = useState(false);
  const [iteration, setIteration] = useState(1);

  async function handleChange(file) {
    let fd = new FormData();
    fd.append('photo', file);

    setProcessing(true);
    let res = await wsCreate(`base/furniture/${model.id}/photo`, fd);

    if (res.success) {
      showNotify(res.message);
      //el ?v= fuerza al navegador a recargarla: la URL no cambia al reemplazarla
      setOpen({ ...model, file_url: `${res.data.file_url}?v=${iteration}` });
      setIteration((it) => it + 1);
      setProcessing(false);
      reload();
    } else {
      setProcessing(false);
      showNotify(res.message, 'error');
    }
  }

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      hideSave
      maxWidth="sm"
      title={`Foto del mueble - ${model?.description || ''}`}
    >
      {model?.file_url && !processing && (
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            minHeight: '200px',
            overflow: 'hidden',
            marginBottom: '20px'
          }}
        >
          <img src={model.file_url} alt="Mueble" style={{ width: '100%' }} />
        </div>
      )}

      {processing && (
        <div style={{ width: '350px', height: '200px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ alignSelf: 'center', width: '60px', height: '60px', marginTop: '45px' }}>
            <div className="lds-dual-ring"></div>
          </div>
        </div>
      )}

      <FileUploader
        handleChange={handleChange}
        name="photo"
        types={fileTypes}
        disabled={processing}
        label="Has click o arrastra una imagen aquí"
        hoverTitle="Suelta la imagen aquí"
        maxSize={2}
      />
    </ModalBase>
  );
}
